const Solana = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_52_1257)">
      <path
        d="M2.20023 8.75703C2.2738 8.68347 2.37265 8.64209 2.47609 8.64209H12.0508C12.2255 8.64209 12.3129 8.85358 12.1887 8.97542L10.2968 10.8674C10.2232 10.9409 10.1244 10.9823 10.0209 10.9823H0.44621C0.271497 10.9823 0.184141 10.7708 0.308279 10.649L2.20023 8.75703Z"
        fill="currentColor"
      />
      <path
        d="M2.20023 1.69502C2.2738 1.62146 2.37265 1.58008 2.47609 1.58008H12.0508C12.2255 1.58008 12.3129 1.79157 12.1887 1.91341L10.2968 3.80307C10.2232 3.87663 10.1244 3.91801 10.0209 3.91801H0.44621C0.271497 3.91801 0.184141 3.70652 0.308279 3.58468L2.20023 1.69502Z"
        fill="currentColor"
      />
      <path
        d="M10.2968 5.20308C10.2232 5.12951 10.1244 5.08813 10.0209 5.08813H0.44621C0.271497 5.08813 0.184141 5.29963 0.308279 5.42147L2.20023 7.31112C2.2738 7.38469 2.37265 7.42607 2.47609 7.42607H12.0508C12.2255 7.42607 12.3129 7.21457 12.1887 7.09273L10.2968 5.20308Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_52_1257">
        <rect
          width="12"
          height="12"
          fill="currentColor"
          transform="translate(0.25 0.292725)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Solana;
